import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SubscriptionsListPage from "../../components/subscription.jsx/SubscriptionsListPage";

const SubscriptionsPage  = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Subscriptions" />
                <SubscriptionsListPage/>
            </MasterLayout>
        </>
    );
};

export default SubscriptionsPage ;
